import { Col, Row } from "react-bootstrap";
import CircularHeaderComponent from "../../components/CircularEconomyHeaderComponent";

const HeaderSubComponent = () => {
  return (
    <div>
      <Row className="mb-1">
        <Col className="col-md-12">
          <h1>Circular Economy Register</h1>
        </Col>
      </Row>
      <Row>
        <Col className="col-md-12">
          <h5>{"  "}</h5>
        </Col>
      </Row>
    </div>
  );
};

const Header = () => {
  const headerContent = <HeaderSubComponent />;
  return <CircularHeaderComponent headerContent={headerContent} />;
};

export default Header;
